import { cn } from '@brew/ui/cn'

/**
 * Permissions every hosted player (YouTube, Loom) asks for. One list, so a
 * new embed never ships a narrower or wider allow-list by accident.
 */
const VIDEO_EMBED_ALLOW =
  'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'

export type VideoEmbedFrameProps = {
  /** Provider embed URL (YouTube `/embed/…`, Loom `/embed/…`). */
  src: string
  /** Accessible name of the frame. */
  title: string
  /** Classes on the 16:9 box the player fills. */
  className?: string
  /** Classes on the `<iframe>` itself (e.g. `pointer-events-none` mid-drag). */
  frameClassName?: string
  /** Defer the player until it nears the viewport. */
  loading?: 'lazy' | 'eager'
}

/**
 * The one hosted-video frame: a 16:9 box with the provider iframe filling
 * it, full-screen allowed, the shared permission list. Providers differ only
 * in `src`, so the DNS walkthrough, the founder Loom, the university dock,
 * and the overview reel all render through here.
 */
export function VideoEmbedFrame({
  src,
  title,
  className,
  frameClassName,
  loading,
}: VideoEmbedFrameProps) {
  return (
    <div className={cn('relative aspect-video w-full', className)}>
      <iframe
        src={src}
        title={title}
        className={cn('absolute inset-0 size-full border-0', frameClassName)}
        allow={VIDEO_EMBED_ALLOW}
        allowFullScreen
        loading={loading}
      />
    </div>
  )
}
